import { Routes, Route, Navigate } from 'react-router-dom';
import { RequireAuth } from './RequireAuth';
import { RequireAdmin } from './RequireAdmin';
import { AuthLayout } from '../layouts/AuthLayout';
import { PlayerLayout } from '../layouts/PlayerLayout';
import { AdminLayout } from '../layouts/AdminLayout';

import { Login } from '../pages/auth/Login';
import { Register } from '../pages/auth/Register';
import { VerifyEmail } from '../pages/auth/VerifyEmail';
import { ForgotPassword } from '../pages/auth/ForgotPassword';

import { Dashboard } from '../pages/player/Dashboard';
import { WalletPage } from '../pages/player/Wallet';
import { Profile } from '../pages/player/Profile';
import { SlotMachinePage } from '../pages/player/SlotMachine';
import { RoulettePage } from '../pages/player/Roulette';
import { BlackjackPage } from '../pages/player/Blackjack';

import { AdminDashboard } from '../pages/admin/AdminDashboard';
import { AdminUsers } from '../pages/admin/AdminUsers';
import { AdminPayments } from '../pages/admin/AdminPayments';
import { AdminGames } from '../pages/admin/AdminGames';

export function AppRouter() {
  return (
    <Routes>
      {/* Public auth routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>

      {/* Authenticated player routes */}
      <Route element={<RequireAuth />}>
        <Route element={<PlayerLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/wallet" element={<WalletPage />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/games/slot" element={<SlotMachinePage />} />
          <Route path="/games/roulette" element={<RoulettePage />} />
          <Route path="/games/blackjack" element={<BlackjackPage />} />
        </Route>

        {/* Admin routes (additionally guarded) */}
        <Route element={<RequireAdmin />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/payments" element={<AdminPayments />} />
            <Route path="/admin/games" element={<AdminGames />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
